import React, { createContext, useContext, useState, useEffect } from 'react';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [token, setToken] = useState(null);
  const [loading, setLoading] = useState(true);
  const [pendingRental, setPendingRental] = useState(null);

  useEffect(() => {
    const storedToken = localStorage.getItem('authToken');
    const storedUser = localStorage.getItem('user');

    if (storedToken && storedUser) {
      setToken(storedToken);
      setUser(JSON.parse(storedUser));
    }

    const storedPendingRental = sessionStorage.getItem('pendingRental');
    if (storedPendingRental) {
      setPendingRental(JSON.parse(storedPendingRental));
    }

    setLoading(false);
  }, []);

  const login = (userData, authToken) => {
    setUser(userData);
    setToken(authToken);
    localStorage.setItem('authToken', authToken);
    localStorage.setItem('user', JSON.stringify(userData));
  };

  const logout = () => {
    setUser(null);
    setToken(null);
    localStorage.removeItem('authToken');
    localStorage.removeItem('user');
    sessionStorage.removeItem('pendingRental');
    setPendingRental(null);
  };

  const isAuthenticated = () => {
    return !!token;
  };

  const savePendingRental = (rentalData) => {
    setPendingRental(rentalData);
    sessionStorage.setItem('pendingRental', JSON.stringify(rentalData));
  };

  const clearPendingRental = () => {
    setPendingRental(null);
    sessionStorage.removeItem('pendingRental');
  };

  const value = {
    user,
    token,
    loading,
    pendingRental,
    login,
    logout,
    isAuthenticated,
    savePendingRental,
    clearPendingRental,
  };

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};

export default AuthContext;
